import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { validateState, VALIDATION_EMPTY_FIELD } from '../hooks/useForm/validate';
import { useValidateState } from '../hooks/useValidateState';
import { checkExistValue } from '../../service/utils';

export const useCustomField = (validator, onEditField, onChangeValue, defaultValue, value, helperText, required) => {
    const { t: translate, i18n } = useTranslation();

    const [currentValue, changeValue] = useState(defaultValue !== undefined && defaultValue !== null ? defaultValue : value);
    const [errorText, changeError] = useValidateState(validator, defaultValue, required, translate);

    let customHelperText = errorText || helperText || '';

    // Не показываем текст ошибки, когда поле не заполнено. Только подсвечиваем
    if (customHelperText === translate(VALIDATION_EMPTY_FIELD)) {
        customHelperText = '';
    }

    useEffect(() => {
        if (checkExistValue(defaultValue)) {
            changeValue(defaultValue);
            changeError((validateState(validator, defaultValue, required, translate) || {}).errorText);
        }
    }, [required, defaultValue, helperText, validator, translate, i18n.language]);

    useEffect(() => {
        changeError((validateState(validator, currentValue, required, translate) || {}).errorText);
    }, [i18n.language, validator, required, translate]);

    const handleEdit = useCallback(
        (evt) => {
            const fieldValue = evt.currentTarget.value === '' ? undefined : evt.currentTarget.value;
            const validateRes = validateState(validator, fieldValue, required, translate);

            if (validateRes === null || validateRes.errorText === translate(VALIDATION_EMPTY_FIELD)) {
                onEditField(evt.target.name, fieldValue);

                if (onChangeValue) {
                    onChangeValue(fieldValue);
                }
            } else {
                changeError(validateRes.errorText);
            }
        },
        [required, onEditField, validator, translate]
    );

    const handleChange = useCallback((event) => changeValue(event.target.value), []);

    const handleInputFocus = useCallback(() => {
        if (errorText) {
            changeError('');
        }
    }, [errorText]);

    return {
        currentValue,
        customHelperText,
        errorText,
        handleChange,
        handleEdit,
        handleInputFocus,
    };
};
